
import React from 'react';

export default class DekorInput extends React.Component {

    static MAX_COLLAPSED_ITEMS = 8;

    state = {
        open: false,
        value: this.props.value,
        stile: this.getStile(),
    };

    getStile() {
        const stile = _.orderBy(APP.metadata.MaterialStile, ['Anzeigereihenfolge'], ['asc']);
        return stile.map(stil=>({
            ...stil,
            toggleOpen: false,
            dekore: _.orderBy(this.props.dekore.filter(dekor=>dekor!=null && dekor.Stil==stil.Name && dekor.Hersteller==stil.Hersteller), ['Anzeigereihenfolge'], ['asc'])
        }));
    }

    clicked(dekor) {
        this.props.setValue(dekor.Artikelnummer, {next:false});
        this.setState({open: !this.props.autoclose, value: dekor.Artikelnummer})
    }

    close() {
        this.props.setValue(this.state.value, {next:true});
        this.setState({open: false})
    }

    render() {
        const dekor = this.props.dekore.find(dekor => dekor!=null && dekor.Artikelnummer==this.state.value);
        if (dekor==null) {
            console.warn('missing Material Artikelnummer='+this.state.value,this.props.dekore.map(d=>d.Artikelnummer));
        }

        return (
            <div className={"dekor " + (this.props.hidden?"disappear":"appear")+' '+(this.state.open?'dekor-open':'dekor-closed')}>
                <label htmlFor="sample-input-1">{this.props.label}</label>
                {dekor &&
                <div className="dekor-input" onClick={() => this.setState({open: !this.state.open})}>
                    <div
                        key="currentValue"
                        className="dekor-item dummyproduct stopselect"
                        style={{background: 'url(' + encodeURI(dekor.TextureUrl) + ')'}}
                        title={dekor.Anzeigename}
                    ></div>
                    <div className="dekor-name">
                        {dekor.Anzeigename}
                    </div>
                    <div className="dekor-select">
                        {this.state.open &&
                        <a className="button icon"><span
                            className="icon down"/></a>
                        }
                        {!this.state.open &&
                        <a className="button icon"><span
                            className="icon down"/></a>
                        }
                    </div>
                </div>
                }
                {this.state.open &&
                <React.Fragment>
                    <div className="dekor-list">
                    {this.state.stile.filter(stil=>stil.dekore.length>0).map((stil, index) =>(
                        <div className="dekor-stil" key={index}>
                            <h4>
                                <span className="dekor-stil-name">{stil.Name}</span>
                                <img className="dekor-hersteller" height={"15px"} src={SETTINGS.wkfgContentBaseUrl + "img/logo-" + stil.Hersteller +".png"}></img>
                            </h4>
                            <div className="dekor-stil-list">
                                {(stil.toggleOpen
                                        ? stil.dekore
                                        : stil.dekore.slice(0,DekorInput.MAX_COLLAPSED_ITEMS)
                                ).map(dekor=>(
                                    <div
                                        key={dekor.Artikelnummer}
                                        data-toggle="tooltip"
                                        data-placement="top"
                                        data-container="body"
                                        id={"korpus-" + dekor.Artikelnummer}
                                        className="dekor-item dummyproduct stopselect"
                                        data-decor-title={dekor.Name}
                                        url={dekor.TextureUrl}
                                        style={{background: 'url(' + encodeURI(dekor.TextureUrl) + ')'}}
                                        title={dekor.Name}
                                        onClick={() => this.clicked(dekor)}
                                    ></div>
                                ))}
                                {stil.dekore.length>DekorInput.MAX_COLLAPSED_ITEMS && (
                                    <div className={"dekor-collapse"}><a className="" onClick={() => {
                                        stil.toggleOpen = !stil.toggleOpen;
                                        this.setState(this.state);
                                    }}>{I18N(stil.toggleOpen ? "Weniger" :  "Mehr")}...</a></div>
                                )}
                            </div>
                        </div>
                    ))}
                    </div>
                    <div className="button-wrapper text-left">
                        <button className="button primary" onClick={() => this.close()} href="#">{I18N("Dekor wählen")}</button>
                    </div>
                </React.Fragment>
                }
            </div>
        )
    }

}
